const HeaderSection = ({ categorie, textColor, borderColor }) => (
  <div
    className={`flex justify-start items-center uppercase tracking-wide font-figtree text-base text-${textColor} font-semibold leading-none mt-2 border-b border-r border-${borderColor} dark:border-silver-100 pb-2 mt-8 mb-5 mr-4 dark:text-crystal-bell`}
  >
    {categorie}
  </div>
);

export default HeaderSection;
